import React from "react";

export default function Modal({
  children,
  handleClose,
  title,
  description,
  central,
  width,
  icon,
  leftAlign,
  cross,
  avatarGroup,
  inLine,
}: {
  children: any;
  handleClose: any;
  title: string;
  description?: string;
  central?: boolean;
  width?: string;
  icon?: string | React.ReactNode;
  leftAlign?: boolean;
  cross?: boolean;
  avatarGroup?: React.ReactNode;
  inLine?: boolean;
}) {
  return (
    <div className="fixed inset-0 bg-backdrop-bg bg-opacity-25 backdrop-blur-sm z-[100]">
      <div
        className={
          central
            ? "justify-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none rounded shadow-lg w-full items-center h-full"
            : "overflow-y-auto sm:max-h-full fixed top-0 right-0 left-0 z-50 w-full inset-0 h-modal md:h-full "
        }
      >
        {/*content*/}
        <div
          className={`${!central && "m-6 "} ${width ? width : "max-w-sm"} p-6 mx-auto border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none`}
        >
          {/*header*/}
          <div className="flex items-center flex-col justify-center rounded-t">
            {cross && (
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-1 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={handleClose}
              >
                <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            )}
            <div className="w-full flex flex-col gap-x-2 pb-2">
              {/* {icon &&
                (typeof icon === "string" ? (
                  <img
                    src={icon}
                    alt={"Icon"}
                    className="max-w-fit max-h-fit cursor-pointer"
                  />
                ) : (
                  <div className="bg-brand-50 p-2 rounded-full max-w-fit mx-auto">
                    <div className="w-8 h-8 bg-brand-100 rounded-full flex justify-center items-center text-customGreen-primary">
                      {icon}
                    </div>
                  </div>
                ))} */}
              {avatarGroup && avatarGroup}

              <div className={inLine ? "flex items-center gap-x-4" : ""}>
                {icon &&
                  (typeof icon === "string" ? (
                    <img
                      src={icon}
                      alt={"Icon"}
                      className="max-w-fit max-h-fit cursor-pointer"
                    />
                  ) : (
                    <>
                      <div className="flex justify-center mb-2">
                        <div className="bg-brand-50 p-2 rounded-full max-w-fit flex justify-center items-center text-center">
                          <div className="w-8 h-8 bg-brand-100 rounded-full flex justify-center items-center text-customGreen-primary">
                            {icon}
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                <h3
                  className={`text-lg font-semibold ${
                    leftAlign ? "text-left w-full" : "text-center w-full"
                  }`}
                >
                  {title}
                </h3>
              </div>
            </div>
            {description && (
              <div
                className={`w-full ${(icon || avatarGroup) && inLine ? "pt-2" : "pt-0"}`}
              >
                <h5
                  // className="text-sm text-center"
                  className={`text-sm text-gray-600 font-normal
                    ${
                      leftAlign
                        ? "text-left w-full text-gray-500 mb-1"
                        : "text-center w-full"
                    }`}
                >
                  {description}
                </h5>
              </div>
            )}
          </div>
          <div> {children}</div>
        </div>
      </div>
    </div>
  );
}
